// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"54de1ca5","428":"4025bb15"}[chunkId] + ".chunk.js";
};